<template>


    <div class="container mt-5">
        <div class="row justify-content-center">
            <div class="col-6">
                <select class="form-select" v-model="programID">
                    <option value="0">პროგრამა</option>
                    <option :value="program.programID" v-for="program in programs" :key="program.programID">{{program.program_name}} ({{ program.program_types.program_type }})</option>

                    </select>
            </div>
        </div>

 

        <div class="container mt-5">

            <table class="table" v-if="journalInfo.length>0">
                <thead>
                    <tr>
                        <th>უწყისის  ნომერი </th>
                        <th>პროფესიული საგანმანათლებლო პროგრამის დასახელება
                        </th>
                        <th>მოდულის დასახელება
                        </th>
                        <th>უწყისის შევსების თარიღი
                        </th>
                        <th>შენიშვნა
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="data of journalInfo">
                        <td>{{ data.groupN }}</td>
                        <td>{{ data.program_name }}</td>
                        <td>{{ data.module_name }}</td>
                        <td>{{ data.printDay }}</td>
                        <td v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6 || this.$store.state.user.positionID==10" > 
                            <textarea v-model="comment[data.groupN]" class="form-control" @blur="saveComment(data.groupN)"></textarea>
                        </td>
                        <td v-if="this.saved[data.groupN]" style="font-size: 20px; color: green;"><i class='bx bxs-check-circle'></i></td>
                    </tr>
                </tbody>

            </table>



        </div>


    </div>


    
</template>
<script>

import HttpRequests from '../httpRequests/httpRequests'
 const httpRequests= new HttpRequests()
export default{

    data(){
        return{

            programID:0,
            programs:[],
            journalInfo:[],
            comment:{},
            saved:{}

        }
    },

    watch:{

        programID(val){

            if(val){
               this.getJournalInfo(val)
            }

        }

    },

    mounted(){

        this.getGroups()

    },
    methods:{

        getJournalInfo(programID){
            httpRequests.getJournalInfo(programID).then(response=>{

                    this.journalInfo=response.data


                    for(let data of response.data){

                        this.comment[data.groupN]=data.comment
                        this.saved[data.groupN]=false

                    }

                    })
        },


        getGroups(){
            httpRequests.getPrograms().then(response=>{
                this.programs=response.data
                })
        },
        saveComment(groupN){

            if(this.comment[groupN]){
                 
                httpRequests.saveJournalComment(groupN,this.comment[groupN]).then(()=>{

                   

                    this.saved[groupN]=true

                    setTimeout(()=>{

                        this.getJournalInfo(this.programID)
                    },2000)

                })

            } 

            

        }


    }


}

</script>